import { render } from "./FormInitiateProcess.html?vue&type=template&id=180f5cd8&scoped=true&ts=true"
import script from "./FormInitiateProcess.ts?vue&type=script&lang=ts"
export * from "./FormInitiateProcess.ts?vue&type=script&lang=ts"

import "./FormInitiateProcess.scss?vue&type=style&index=0&id=180f5cd8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180f5cd8"]])

export default __exports__